module.exports = __webpack_public_path__ + "img/retreat.7f9183ff.svg";